<div role="tabpanel" class="tab-pane active" id="loading">
    <div class="loading">
        <div class="loading-containner">
            <img src="assets/images/loading.gif" alt="Carregando">

        </div>
        <div class="animated-words">
            <span>Consultando Dados...</span>
            <span>Realizando Simulação...</span>
            <span>Verificando Valores...</span>
            <span>Checando Dados...</span>
            <span>Verificando o Sistema...</span>
            <span>Aguardando Resposta...</span>
        </div>
    </div>
</div>

<app-modal-message #modalMessage [title]="'Atenção!'" [hideClose]="hideClose"></app-modal-message>

<app-modal #messageReturnHome title="Atenção!" [hideClose]="true">
    <h4>Enquanto é gerado o resultado parcial para esta ficha, você será redirecionado à tela Minhas Fichas.</h4>
    <h4>Em alguns instantes, você poderá consultar as informações desta ficha.</h4>
</app-modal>